module.exports = __webpack_public_path__ + "img/fourth-onboarding-2.2437dc7e.png";